<div class="row question">
  <span class="col-1 text-center">Q:</span>
  <span class="col-11">{{ question() }}</span>
</div>
<div class="row answer">
  <span class="col-1 text-center">A:</span>
  <span class="col-11">{{ answer() }}</span>
</div>
